export default {
    loading: false,
    error: {},
    report: {},
    reports: [],
    newincident: null,
}